import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';
import styled from 'styled-components';
import Spinner from '../UI/Spinner';
import roleStore from '../../stores/rolesStore';
import versionStore from '../../stores/versionStore';
import isPrivateSite from '../../utils/is-private-site-util';
import { sortByRoleType } from '../../utils/sort-list-util';


const CheckboxContainer = styled.div`
display: flex;
justify-content: center;
position: absolute;
left: -2%;
top: 10%;
bottom: 10%;
aspect-ratio: 1 / 1;
border-radius: 100%;
background-color: #fff;
background-image: url("./images/website/casino.svg");
background-size: 12px 12px;
background-repeat: no-repeat;
background-position: center center;

&:hover {
  opacity: 0.5;
}

${props => `
  opacity: ${props.isChecked ? '1' : '0'};
`}

`;

const Checkbox = styled.input`
margin: 0 !important;
opacity: 0 !important;
width: 100%;
height: 100%;
cursor: pointer;
`;

function VersionRole({
  role,
  removeRole,
  shuffleLock,
  getTooltipContent,
  onMouseDown,
  isMouseDown
  }) {

  let jinxRoles = [];
  let checkedLock = false;
  let tetherWarning = '';
  let restrictionWarning = '';
  let tooltip = '';

  if ( role.jinx ) {
    for ( let i in role.jinx ) {
      let jinxRole = roleStore.getRole(role.jinx[i].id);

      if ( versionStore.checkRole(jinxRole)) {
        jinxRoles.push({
          key: "jinx_" + role.jinx[i].id,
          src: jinxRole.icon,
          title: role.jinx[i].reason,
          roleType: jinxRole.roleType,
          id: jinxRole.id,
        });
      }
    }

    jinxRoles.sort(sortByRoleType);

    jinxRoles = jinxRoles.map(data => <img key={data.key} src={data.src} title={data.title}/>);
  }


  if ( role.shuffleLock === true ) {
    checkedLock = true;
  }

  if ( role.tetherWarning ) {
    tetherWarning = <span>
      <span
        className="version-role__tether"
        data-tip={role.tetherWarning}
      > </span>
      <ReactTooltip />
    </span>;
  }

  if ( role.restrictionWarning ){
    restrictionWarning = <span>
      <span
        className="version-role__restriction"
        data-tip={role.restrictionWarning}
      > </span>
      <ReactTooltip />
    </span>;
  }

  if ( isPrivateSite() ){
    // showing the tooltip only for the private site for the moment as there is a performance issue in Chrome, when dragging a row in a list with at least two rows
    tooltip = <ReactTooltip id={'versionRoleTooltip_' + role.id}
      globalEventOff={'click'} // this is a workaround to issue where the tooltip appears and doesn't hide after sort/drag release -- so user can click empty area to hide tooltip
      disable={isMouseDown} // this and empty function in getContent is used to disable tooltip when rows are being sorted -- using both because of issue described above, and want to make sure it's disabled, so doing both just in case
      getContent={isMouseDown ? () => {return null} : getTooltipContent}
      effect='solid'
      delayHide={500}
      delayShow={1000}
      delayUpdate={500}
      place={'bottom'}
      border={true}
      type={'dark'}
    />
  }

  return (<li data-id={role.id} className={classNames('version-role', !checkedLock && 'version-role--locked')}>
      <CheckboxContainer isChecked={!checkedLock}>
        <Checkbox type="checkbox" checked={!checkedLock} onChange={() => shuffleLock(role)} title="This character has been added at random. To add it permanently, click this icon."/>
      </CheckboxContainer>
      <div
        data-id={"loading_" + role.id}
        className={classNames(
          "version-role__loading",
          {
            "version-role__loading--good": role.roleType === "townsfolk" || role.roleType === "outsider",
            "version-role__loading--evil": role.roleType === "minion" || role.roleType === "demon"
          }
        )}>
          <Spinner />
      </div>
      <span data-id={"img_" + role.id} className="version-role__print" onMouseDown={onMouseDown} onClick={() => removeRole(role)} data-for={'versionRoleTooltip_' + role.id} data-tip={role.id}>
        <img
          src={role.print}
          onLoad={() => {
            document.querySelectorAll("[data-id='loading_" + role.id + "']")[0].style.display = 'none';
            document.querySelectorAll("[data-id='img_" + role.id + "'] img")[0].style.display = 'inline';
          }}
          onError={() => {
            document.querySelectorAll("[data-id='loading_" + role.id + "']")[0].style.display = 'none';
            document.querySelectorAll("[data-id='img_" + role.id + "'] img")[0].style.display = 'inline';
          }}
        />
      </span>

      {tooltip}

      <span className="version-role__jinx">{jinxRoles}</span>
      {tetherWarning}
      {restrictionWarning}
    </li>
  );
}

VersionRole.propTypes = {
  role: PropTypes.object.isRequired,
  removeRole: PropTypes.func,
  shuffleLock: PropTypes.func,
  getTooltipContent: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  isMouseDown: PropTypes.bool.isRequired,
};

export default VersionRole;
